exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".like-btn[data-v-b449a2f4]{width:59px;padding-left:25px}.disable-hover-effect[data-v-b449a2f4]{color:#363636;cursor:pointer;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-bottom:calc(.375em - 1px);padding-left:.75em;padding-right:.75em;padding-top:calc(.375em - 1px);text-align:center;white-space:nowrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.reviews[data-v-b449a2f4]{height:500px;overflow-y:auto}", ""]);

// exports
